<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
  <span class="dialog-header">{{action}} Proof of Concepts</span>
  <i mat-dialog-close class="fa fa-times model_close cursor-pointer"></i>
</h1>
<div mat-dialog-content class="content">
  <form class="form" [formGroup]="formData">
    <div class="container">
      <div class="row m-0">
        <div class="col-12 p-0">
          <div class="row m-0">
            <div class="col-md-12">
              <div class="row m-0">
                <div class="col-md-6 pl-md-0 pb-20">
                  <div class="field_heading">
                    <span class="secondaryInfo">Do you have a COE Lead approval for this POC?</span>
                  </div>
                  <mat-radio-group formControlName="hasApproval">
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                  </mat-radio-group>
                </div>
                <div class="col-md-6 pl-md-0 pb-20" [ngClass]="{'disabled': !hasApproval}"
                  [style.opacity]="hasApproval ? 1 : 0.5">
                  <div class="field_heading"><span class="secondaryInfo">Git Mail Proof Url<sup
                        class="error">*</sup></span>
                  </div>
                  <input type="text" class="form-control fs-14 black-clr"
                    [class.is-invalid]="mailProoffile.invalid && (mailProoffile.touched || mailProoffile.dirty)"
                    aria-label="Number" placeholder="Enter Mail Proof Uploaded URL" formControlName="mailProoffile">
                  <div *ngIf="mailProoffile.invalid && (mailProoffile.touched || mailProoffile.dirty)" class="error">
                    Mail Proof Uploaded URL is required
                  </div>
                  <div *ngIf="invalid" class="error">
                    Mail Proof URL is invalid
                  </div>
                </div>
              </div>
            </div>
            <!-- {{hasApproval | json}} -->
            <div [ngClass]="{'disabled': !hasApproval}" [style.opacity]="hasApproval ? 1 : 0.5">
              <div class="col-md-12">
                <!-- <div class="row m-0">
                  <div class="col-md-8 pl-md-0 pb-20">
                    <div class="custom_paragraph">
                      <div class="field_heading"><span class="secondaryInfo">Upload approval mail Proof<sup
                            class="error">*</sup></span>
                      </div>
                      <div class="dropzone" fileDragDrop>
                        <div class="text-wrapper">
                          <div class="upload_section">
                            <input #mailProofFile type="file" class="form-control" formControlName="mailProoffile"
                              name="mailProofFile" id="mailProofFile"
                              (change)="onMailProofFileChange($event.target.files)" onclick="this.value = null"
                              [accept]="allowedFileExtentions">
                            <label for="mailProofFile">
                              <div class="browse-div">
                                <i class="msicon">
                                  <span class="material-symbols-rounded">
                                    backup
                                  </span>
                                </i>
                                <div class="custom_paragraph"> Drag your file(s) or <span class="link">browse</span>
                                </div>
                              </div>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="!mailProofFilesLogo?.fileName && (mailProoffile.invalid && (mailProoffile.touched || mailProoffile.dirty))"
                        class="error">
                        Mail proof is required
                      </div>

                    </div>
                  </div>
                  <div *ngIf="mailProofFilesLogo" class="form-control fileUpload field_value">
                    <div class="avatar"><span class="material-symbols-outlined fs-18 add-circle"> description
                      </span>
                    </div>
                    <div class="file-info">
                      <span class="title">{{ mailProofFilesLogo.fileName }}</span>
                      <span class="sub-info">{{ getFileSize(mailProofFilesLogo.fileSize) }}</span>
                    </div>
                    <a (click)="RemoveMailProof()" class="icon">
                      <span class="material-symbols-outlined fs-18 deleteIcon">delete</span>
                    </a>
                  </div>
                </div> -->
                <div class="row m-0">
                  <div class="col-md-6 pl-md-0 pb-20">
                    <div class="field_heading"><span class="secondaryInfo">Title<sup class="error">*</sup></span>
                    </div>
                    <input type="text" class="form-control fs-14 black-clr"
                      [class.is-invalid]="title.invalid && (title.touched || title.dirty)" aria-label="Number"
                      placeholder="Enter Title" formControlName="title">
                    <div *ngIf="title.invalid && (title.touched || title.dirty)" class="error">
                      Title is required
                    </div>
                    <div *ngIf="invalid" class="error">
                      Title is invalid
                    </div>
                  </div>

                  <div class="col-md-6 pl-md-0 pb-20">
                    <div class="field_heading"><span class="secondaryInfo">URL<sup class="error">*</sup></span>
                    </div>
                    <input type="text" class="form-control fs-14 black-clr"
                      [class.is-invalid]="url.invalid && (url.touched || url.dirty)" aria-label="Number"
                      placeholder="Enter URL" formControlName="url">
                    <div *ngIf="url.invalid && (url.touched || url.dirty)" class="error">
                      URL is required
                    </div>
                    <div *ngIf="invalid" class="error">
                      URL is invalid
                    </div>
                  </div>

                </div>
                <div class="row m-0">
                  <div class="col-md-6 pl-md-0 pb-20">
                    <div class="field_heading"><span class="secondaryInfo">Owner<sup class="error">*</sup></span>
                    </div>
                    <input type="text" class="form-control fs-14 black-clr"
                      [class.is-invalid]="owner.invalid && (owner.touched || owner.dirty)" aria-label="Number"
                      placeholder="Enter Owner Email" formControlName="owner" matInput
                      (input)="getFilteredEmails($event.target.value, 'ownerEmailsDropdown')"
                      [matAutocomplete]="populateOwner" (blur)="validateEmail('owner', this.ownerEmailsDropdown);">
                    <mat-autocomplete #populateOwner="matAutocomplete"
                      (optionSelected)="validateEmail('owner', this.ownerEmailsDropdown);">
                      <mat-option *ngFor="let user of ownerEmailsDropdown" [value]="user.userEmail">
                        {{ user.userEmail }}
                      </mat-option>
                    </mat-autocomplete>
                    <div *ngIf="owner.invalid && (owner.touched || owner.dirty) || ownerErrorMessage" class="error">
                      {{ ownerErrorMessage }}
                    </div>
                    <div *ngIf="invalid" class="error">
                      Owner is invalid
                    </div>
                  </div>

                  <div class="col-md-6 pl-md-0 pb-20">
                    <div class="field_heading"><span class="secondaryInfo">Point of Contact<sup
                          class="error">*</sup></span>
                    </div>
                    <input type="text" class="form-control fs-14 black-clr"
                      [class.is-invalid]="pointOfContact.invalid && (pointOfContact.touched || pointOfContact.dirty)"
                      aria-label="Number" placeholder="Enter Point Of Contact Email" formControlName="pointOfContact"
                      matInput (input)="getFilteredEmails($event.target.value, 'pocEmailDropdown')"
                      [matAutocomplete]="populatePOC" (blur)="validateEmail('pointOfContact', this.pocEmailDropdown);">
                    <mat-autocomplete #populatePOC="matAutocomplete"
                      (optionSelected)="validateEmail('pointOfContact', this.pocEmailDropdown);">
                      <mat-option *ngFor="let user of pocEmailDropdown" [value]="user.userEmail">
                        {{ user.userEmail }}
                      </mat-option>
                    </mat-autocomplete>
                    <div
                      *ngIf="pointOfContact.invalid && (pointOfContact.touched || pointOfContact.dirty) || pointOfContactErrorMessage"
                      class="error">
                      {{ pointOfContactErrorMessage }}
                    </div>
                    <div *ngIf="invalid" class="error">
                      Point of Contact is invalid
                    </div>
                  </div>

                </div>
                <div class="row m-0">
                  <div class="col-md-6 pl-md-0 pb-20">
                    <div class="field_heading"><span class="secondaryInfo">Source Code Path(URL)<sup
                          class="error">*</sup></span>
                    </div>
                    <input type="text" class="form-control fs-14 black-clr"
                      [class.is-invalid]="sourceCodeUrl.invalid && (sourceCodeUrl.touched || sourceCodeUrl.dirty)"
                      aria-label="Number" placeholder="Enter Source Code Path URL" formControlName="sourceCodeUrl">
                    <div *ngIf="sourceCodeUrl.invalid && (sourceCodeUrl.touched || sourceCodeUrl.dirty)" class="error">
                      Source Code Path Url is required
                    </div>
                    <div *ngIf="invalid" class="error">
                      Source Code Path Url is invalid
                    </div>
                  </div>
                  <div class="col-md-6 pl-md-0 pb-20">

                    <div class="custom_paragraph">
                      <div class="field_heading adjust"><span class="secondaryInfo">Service Line<sup
                            class="error">*</sup></span>
                      </div>
                      <div class="form-control multiSelect-textbox field_value custom_Scrollbar"
                        [class.is-invalid]="(isTouched.ServiceLine && selectedServiceLines?.length == 0) || serviceLine.invalid && (serviceLine.touched || serviceLine.dirty)">
                        <app-typeahead-textbox [allValues]="serviceLinesForDropDown"
                          [formControl]="formData.get('serviceLine')" [values]="serviceLinesForDropDown2"
                          placehold="Select Service Line"
                          (emittedValues)="getServiceLinesForDropDownvalues($event)"></app-typeahead-textbox>

                      </div>
                      <div
                        *ngIf="(isTouched.ServiceLine && selectedServiceLines?.length == 0) || serviceLine.invalid && (serviceLine.touched || serviceLine.dirty)"
                        class="error">
                        Service Line is required
                      </div>
                    </div>
                  </div>

                </div>
                <div class="row m-0">
                  <div class="col-md-6 pl-md-0 pb-20">
                    <div class="custom_paragraph">
                      <div class="field_heading"><span class="secondaryInfo">Service Offering
                          <sup class="error">*</sup></span>
                      </div>
                      <div class="form-control multiSelect-textbox field_value custom_Scrollbar"
                        [class.is-invalid]="(isTouched.ServiceOffering && selectedServiceOffering?.length == 0) ||serviceOfferings.invalid && (serviceOfferings.touched || serviceOfferings.dirty)">
                        <app-typeahead-textbox [allValues]="serviceOfferingForDropDown"
                          [formControl]="formData.get('serviceOffering')" [values]="serviceOfferingForDropDown2"
                          placehold="Select Service Offering"
                          (emittedValues)="getServiceOfferingForDropDownvalues($event)"></app-typeahead-textbox>

                      </div>
                      <div
                        *ngIf="(isTouched.ServiceOffering && selectedServiceOffering?.length == 0) ||serviceOfferings.invalid && (serviceOfferings.touched || serviceOfferings.dirty)"
                        class="error">
                        Service Offering is required
                      </div>
                    </div>

                  </div>

                  <div class="col-md-6 pl-md-0 pb-20">
                    <div class="custom_paragraph">
                      <div class="field_heading"><span class="secondaryInfo">Tech Stacks<sup
                            class="error">*</sup></span>
                      </div>
                      <div class="form-control multiSelect-textbox field_value custom_Scrollbar"
                        [class.is-invalid]="(isTouched.TechStack && selectedTechStack?.length == 0) || techStackControl.invalid && (techStackControl.touched || techStackControl.dirty)">
                        <ng-container>
                          <app-typeahead-textbox [formControl]="formData.get('techStack')"
                            [allValues]="techStackForDropDown" [values]="techStackForDropDown2"
                            placehold="Select Tech Stack"
                            (emittedValues)="getTechStackValues($event)"></app-typeahead-textbox>
                        </ng-container>
                      </div>
                      <div
                        *ngIf="(isTouched.TechStack && selectedTechStack?.length == 0) || techStackControl.invalid && (techStackControl.touched || techStackControl.dirty)"
                        class="error">
                        Tech Stack is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row m-0">
                  <div class="col-md-6 pl-md-0 pb-20">
                    <div class="field_heading"><span class="secondaryInfo">Demo Link<sup class="error">*</sup></span>
                    </div>
                    <input type="text" class="form-control fs-14 black-clr"
                      [class.is-invalid]="demoUrl.invalid && (demoUrl.touched || demoUrl.dirty)" aria-label="Number"
                      placeholder="Enter Demo Link URL" formControlName="demoUrl">
                    <div *ngIf="demoUrl.invalid && (demoUrl.touched || demoUrl.dirty)" class="error">
                      Demo Link is required
                    </div>
                    <div *ngIf="invalid" class="error">
                      Demo Link is invalid
                    </div>
                  </div>
                  <div class="col-md-6 pl-md-0 pb-20">
                    <div class="field_heading"><span class="secondaryInfo">Readme Link<sup class="error">*</sup></span>
                    </div>
                    <input type="text" class="form-control fs-14 black-clr"
                      [class.is-invalid]="readMeUrl.invalid && (readMeUrl.touched || readMeUrl.dirty)"
                      aria-label="Number" placeholder="Enter Readme Link URL" formControlName="readMeUrl">
                    <div *ngIf="readMeUrl.invalid && (readMeUrl.touched || readMeUrl.dirty)" class="error">
                      Readme Link is required
                    </div>
                    <div *ngIf="invalid" class="error">
                      Readme Link is invalid
                    </div>
                  </div>

                </div>
                <div class="row m-0">
                  <div class="col-md-8 pl-md-0 pb-20">
                    <div class="custom_paragraph">
                      <div class="field_heading"><span class="secondaryInfo">Logo<sup class="error">*</sup></span>
                      </div>
                      <div class="dropzone" fileDragDrop>
                        <div class="text-wrapper">
                          <div class="upload_section">
                            <input #file type="file" class="form-control" formControlName="files" name="file" id="file"
                              (change)="onFileChange($event.target.files)" [accept]="allowedLogoExtentions">
                            <label for="file">
                              <div class="browse-div">
                                <i class="msicon">
                                  <span class="material-symbols-rounded">
                                    backup
                                  </span>
                                </i>
                                <div class="custom_paragraph"> Drag your file(s) or <span class="link">browse</span>
                                </div>
                              </div>
                            </label>
                          </div>

                        </div>
                      </div>
                      <div *ngIf="!logo?.fileName && files.invalid && (files.touched)" class="error">
                        Logo is required
                      </div>
                    </div>
                    <div *ngIf="logo?.fileName" class="form-control fileUpload field_value">
                      <div class="avatar"><span class="material-symbols-outlined fs-18 add-circle"> description
                        </span>
                      </div>
                      <div class="file-info">
                        <span class="title">{{logo.fileName}}</span>
                        <span class="sub-info">{{getFileSize(logo.fileSize)}}</span>
                      </div>
                      <a (click)="RemoveLogo()" class="icon"><span class="material-symbols-outlined fs-18 deleteIcon">
                          delete
                        </span></a>
                    </div>
                  </div>

                </div>
                <div class="row m-0">
                  <div class="col-md-8 pl-md-0 pb-20">
                    <div class="custom_paragraph">
                      <div class="field_heading"><span class="secondaryInfo">Meta Data / Description<sup
                            class="error">*</sup></span>
                      </div>
                      <textarea class="form-control description fs-14 black-clr" rows="3"
                        [class.is-invalid]="metaData.invalid && (metaData.touched || metaData.dirty)"
                        formControlName="metaData" placeholder="Enter Meta data"></textarea>
                      <div *ngIf="metaData.invalid && (metaData.touched || metaData.dirty)" class="error">
                        Meta Data is required
                      </div>
                      <div class="error" *ngIf="metaData.hasError('pattern') && !metaData.hasError('required')">
                        Invalid format
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


        </div>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
  <button mat-dialog-close class="custom_btn inverted_btn_base ml-2">Cancel</button>
  <button type="button" class="custom_btn primary_btn_base ml-2" (click)="saveData($event)" [disabled]="formData.get('hasApproval')?.value !== true" [ngStyle]="{
    'opacity': hasApproval ? '1' : '0.5',
    'cursor': hasApproval ? 'pointer' : 'default'}" >Save</button>
  </div>